import type { UiSchema } from '@rjsf/utils';
import type { JSONSchema7 } from 'json-schema';

export const schema = {
  type: 'object',
  properties: {
    authValue: { type: 'string', title: 'Auth Value' },
  },
  required: ['authValue'],
  additionalProperties: false,
} satisfies JSONSchema7;

export const uiSchema = {
  authValue: {
    'ui:placeholder': 'Enter or bind the auth value',
  },
} satisfies UiSchema;
